module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE1IDE4Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjQwNTIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTQuMzMzIDE3LjMzMmEuMzUuMzUgMCAwIDEtLjQ0NC4wMy4zOTEuMzkxIDAgMCAxLS4xNTYtLjQxM2wxLjc0LTcuMDc4SC44NTVhLjM1Ny4zNTcgMCAwIDEtLjMzNC0uMjQ1LjM4My4zODMgMCAwIDEgLjEwNi0uNDExTDExLjExLjA4N2EuMzQ5LjM0OSAwIDAgMSAuNDIyIDBjLjEzLjA5LjE5My4yNTQuMTU2LjQxMkw5Ljk1IDcuNTVoNC42MTFjLjE1IDAgLjI4Mi4wOTguMzMzLjI0NC4wNTEuMTQ3LjAxLjMxMS0uMTA1LjQxMkw0LjMzMyAxNy4zMzJ6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/investor/lightning-bolt.svg
// module id = 943
// module chunks = 0